import { Component, EventEmitter, Input, Output } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { MessageService }     from './message.service';

@Component({
  selector: 'navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css'],
  animations: [
    trigger('collapse', [
            state('inactive', style({
                height: '0',
                backgroundColor: '#aaaaaa'
            })),
            state('active', style({
                height: '*',
                backgroundColor: '#223344'
            })),
            transition('inactive => active', animate('200ms ease-in')),
            transition('active => inactive', animate('200ms ease-out'))
        ])
	]
})

export class NavigationComponent {
  state: string = 'inactive';

  @Output() bookClicked = new EventEmitter<boolean>();

  constructor(private messageService: MessageService) {
  }

  toogleCollapse() {
    this.state = (this.state === 'inactive' ? 'active' : 'inactive')
  }

  clickedBook() {
    console.log("NavigationComponent clickedBook")

    //this.bookClicked.emit(true)

    this.messageService.sendMessage('Message from NavigationComponent to Book Component!');
  }

  clickedReviews() {
    console.log("NavigationComponent clickedReviews")

    //this.messageService.sendScrollToReviews('scroll');
  }

  clickedContactUs() {
    console.log("NavigationComponent clickedContactUs")

    this.messageService.sendScrollToContact('scroll');
  }
}



// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/navigation.component.ts